import { useEffect, useState } from "react";
import { useSession } from "../stores/session";
import { Cookies } from "react-cookie";
import LoadingPage from "../pages/layout.tsx/loading";
import { request } from "../api/config-psikolog";

type Props = {
  children: JSX.Element | JSX.Element[];
};

const Private = ({ children }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);

  const { setGetMe } = useSession();

  const cookies = new Cookies();

  const checkSession = async () => {
    try {
      const { data } = await request.get("/profile");
      return data;
    } catch {
      cookies.remove("accessToken", { path: "/" });
      // navigate("/auth/login");
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([checkSession()]).then((res) => {
      setGetMe(res[0]);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{loading ? <LoadingPage /> : <>{children}</>}</>;
};

export default Private;
